import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const CurrentStep = () => (_jsx("div", Object.assign({ className: 'step-menu-circle current' }, { children: _jsx("span", { children: _jsx("i", Object.assign({ className: 'material-icons md-18' }, { children: "create" })) }) })));
export default CurrentStep;
